import { InjectionToken } from '@angular/core';
import { RGBColor } from '@finder/shared/utils/dom/pickHexColor';

export const hexToRGB = (hex: string): RGBColor => {
    let r = -1;
    let g = -1;
    let b = -1;

    if (hex.startsWith('#')) {
        hex = hex.substring(1);
    }

    switch (hex.length) {
        case 6:
            r = Number('0x' + hex[0] + hex[1]);
            g = Number('0x' + hex[2] + hex[3]);
            b = Number('0x' + hex[4] + hex[5]);
            break;
        default:
            r = Number('0x' + hex[0] + hex[0]);
            g = Number('0x' + hex[1] + hex[1]);
            b = Number('0x' + hex[2] + hex[2]);
            break;
    }

    return { r, g, b };
};

export type HexToRGBProvider = (hex: string) => RGBColor;
export const HEX_TO_RGB =
    new InjectionToken('CREATE_STYLE', {
        factory: () => hexToRGB
    });
